import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import * as $ from "jquery";

@Component({
  selector: "app-sample-center-appointments",
  templateUrl: "./sample-center-appointments.component.html",
  styleUrls: ["./sample-center-appointments.component.css"],
})
export class SampleCenterAppointmentsComponent implements OnInit {
  apiUrl: string;
  logSampleForm: FormGroup;
  status: boolean = false;
  dtOptions: any = {};
  submitted = false;
  config: any;
  currentPageLength: any = 10;
  searchObject: any = {};
  appointments: any;
  searchForm: FormGroup;
  centerId: any;
  passengerName: string;
  passengerId: any;
  appointmentId: any;
  appoint_id: any;
  singleAppointmentForm: FormGroup;
  applicationName: string;

  applicationId: string;
  collection_center_appId: any;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit(searchObj = null) {
    this.sess.checkLogin();

    this.applicationId = localStorage.getItem("application_id");
    this.collection_center_appId = environment.APP_ID_COLLECTION_CENTER;
    this.sess.confirmUser(
      this.applicationId,
      this.collection_center_appId,
      "Sample Collection Center"
    );

    this.initialiseForm();
    if (searchObj == null || searchObj == "") {
      this.appointments = "";
      this.initSearchForm();
      this.initTable();
      console.log("searchObj is null");
    } else {
      this.appointments = "";
      console.log("searchObj is not null");
    }

    /* Pagination Start */
    this.config = {
      currentPage: 1,
      itemsPerPage: 10,
    };

    if (this.applicationId === "2") {
      this.getAppointments(this.config.itemsPerPage, this.config.currentPage);
    }

    this.route.queryParams.subscribe(
      (params) =>
        (this.config.currentPage = params["page"] ? params["page"] : 1)
    );
  }

  initSearchForm() {
    this.searchForm = this.formBuilder.group({
      traveller: [""],
      daterangeInput: [""],
      status: [""],
      passportNumber: ["", Validators.minLength(8)],
      appointmentId: ["", Validators.minLength(11)],
    });
    this.singleAppointmentForm = this.formBuilder.group({
      appointmentId: [""],
      fullname: [""],
      phone: [""],
      traveller: [""],
      passportNumber: [""],
      status: [""],
      date: [""],
    });
  }

  showModalData(modal, data) {
    this.utility.showModal(modal);
    this.initSingleAppointment(data);
  }

  showModalLogSample(modal, data) {
    this.getAppointment(data);
    // this.utility.showModal(modal);
  }

  initSingleAppointment(sample) {
    this.singleAppointmentForm = this.formBuilder.group({
      appointmentId: [sample.ctms_passenger_id],
      fullname: [
        `${sample.first_name} ${sample.middle_name} ${sample.last_name}`,
      ],
      phone: [sample.phone],
      passportNumber: [sample.passport_no],
      traveller: [sample.type == 1 ? "DEPARTING" : "ARRIVING"],
      status: [sample.payment_status == 1 ? "Paid" : "Pending"],
      date: [`${sample.booking_date} ${sample.booking_time}`],
    });
  }

  initialiseForm() {
    this.searchForm = this.formBuilder.group({
      traveller: [""],
      daterangeInput: [""],
      passportNumber: [""],
      appointmentId: [""],
    });

    this.logSampleForm = this.formBuilder.group({
      sampleCollectionVia: ["", [Validators.required]],
      specimenType: ["", [Validators.required]],
      passengerName: ["", [Validators.required]],
      testAttendant: ["", [Validators.required]],
    });
  }

  public daterange: any = {};

  public options: any = {
    locale: { format: "YYYY-MM-DD" },
    alwaysShowCalendars: false,
  };

  public selectedDate(value: any, datepicker?: any) {
    // this is the date  selected
    console.log("selectedDate: ", value);

    // any object can be passed to the selected event and it will be passed back here
    // datepicker.start = value.start;
    // datepicker.end = value.end;

    // use passed valuable to update state
    this.daterange.start = value.start.format("YYYY-MM-DD");
    this.daterange.end = value.end.format("YYYY-MM-DD");
    this.daterange.label = value.label;
  }

  initTable() {
    this.dtOptions = {
      paging: false,
      pagingType: "full_numbers",
      responsive: true,
      pageLength: 10,
      lengthChange: false,
      processing: false,
      ordering: false,
      info: false,
      columnDefs: [
        {
          //targets: [ 10 ],
          visible: false,
          searchable: false,
        },
      ],
      dom:
        "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        // { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
        // { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
      ],
    };
  }

  onSearchAppointment(formdata) {}

  getAppointment(id) {
    this.submitted = false;
    this.spinnerService.show();
    this.appoint_id = id;
    let obj = {};
    this.apiUrl = `${environment.AUTHAPIURL}passenger-appointment/` + id;

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, obj, { headers: reqHeader })
      .subscribe((data) => {
        let status = data.status;
        let res = data.response;
        console.log(data);

        if (status) {
          this.appointmentId = `${res.id}`;
          this.passengerName = `${res.first_name} ${res.middle_name} ${res.last_name}`;
          this.passengerId = res.id;
          let testAnalyst = localStorage.getItem("name");
          this.logSampleForm = this.formBuilder.group({
            sampleCollectionVia: ["", [Validators.required]],
            specimenType: ["", [Validators.required]],
            passengerName: [this.passengerName, [Validators.required]],
            testAttendant: [testAnalyst, [Validators.required]],
          });
          this.spinnerService.hide();
          $("#viewLogSampleFormModal").trigger("click");
        } else {
          this.spinnerService.hide();
          // $('#viewStatusModal').trigger('click');
        }
      });
  }

  onSubmitLogSample(formData) {
    this.submitted = true;

    if (this.logSampleForm.invalid) {
      return;
    }

    if (
      !confirm(
        "This action cannot be reverted, Kindly validate the information you have filled in. Do you want to proceed?"
      )
    )
      return;

    const obj = {
      passenger_info_id: this.passengerId,
      // passenger_appointment_id: this.appointmentId,
      specimen_type: formData.specimenType,
      collected_via: formData.sampleCollectionVia,
      user_id: localStorage.getItem("id"),
    };

    this.apiUrl = `${environment.AUTHAPIURL}sample-collection/add`;

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, obj, { headers: reqHeader })
      .subscribe((data) => {
        let status = data.status;
        let res = data.response;
        if (status) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
          $("#viewStatusModal").trigger("click");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              data.response != null ? data.response[0].message : data.message,
            showConfirmButton: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  showModal(modal) {
    this.utility.showModal(modal);
  }

  makePayment(modal) {
    alert("Make Payment Button was clicked");

    this.utility.showModal(modal);
  }

  nextPassenger() {
    this.utility.closeAllModals();
    $("#logSample").trigger("click");
  }

  getAppointments(perpage, pageno) {
    this.spinnerService.show();

    this.apiUrl =
      `${environment.AUTHAPIURL}passenger-appointment-list?page=` + pageno;

    // this.searchObject['center_id'] = 3;
    this.searchObject["per_page"] = perpage;
    this.searchObject["application_id"] =
      localStorage.getItem("application_id");

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, this.searchObject, { headers: reqHeader })
      .subscribe((data) => {
        this.spinnerService.hide();
        console.log(data);
        if (data.status == true) {
          this.appointments = data.response.data;
          this.config.totalItems = data.response.total;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              data.response != null ? data.response[0].message : data.message,
            showConfirmButton: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  pageChange(newPage: number) {
    this.appointments = "";
    this.router.navigate(["/sample-center-appointments"], {
      queryParams: { page: newPage },
    });
    this.getAppointments(this.config.itemsPerPage, newPage);
  }

  public setItemsPerPage(event) {
    this.config.itemsPerPage = event;
    this.currentPageLength = this.config.itemsPerPage;
    this.appointments = "";
    this.router.navigate(["/sample-center-appointments"]);
    this.getAppointments(this.config.itemsPerPage, 1);
  }

  onSubmitSearch(formAllData: any) {
    this.submitted = true;

    // stop the process here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.searchObject = {
      travel_type: formAllData.traveller,
      payment_status: formAllData.status,
      passport_no: formAllData.passportNumber,
      appointment_id: formAllData.appointmentId,
      date_start:
        this.daterange.start !== undefined ? this.daterange.start : null,
      date_end: this.daterange.end !== undefined ? this.daterange.end : null,
    };

    console.log("searchFormData: ", this.searchObject);

    this.appointments = "";
    this.getAppointments(this.config.itemsPerPage, this.config.currentPage);
  }

  clearSearch() {
    this.appointments = "";
    this.searchObject = {};
    this.initialiseForm();
    this.getAppointments(this.config.itemsPerPage, this.config.currentPage);
  }
}
